@if (showSearchInterface) {
  <div class="relative flex grow items-center">
    <input
      #searchInput
      type="search"
      [placeholder]="placeholder || 'Search items' | sentenceCase"
      [(ngModel)]="searchTerm"
      (ngModelChange)="filterItems()"
      class="grow !pl-8"
    />
    <svg-icon
      class="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 text-french-blue-600"
      src="/assets/icons/general/search.svg"
    />
  </div>
}
